import { useQuery } from '@tanstack/react-query'
import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { billing } from '@/api/endpoints'
import { formatDate, formatMoney } from '@/lib/utils'

/**
 * Faktúra po splatnosti - pás pod hlavičkou, kým plynie 14-dňová lehota.
 * Vidí ho každý, lebo pozastavenie sa týka všetkých; odkaz na faktúru len
 * správca, ktorý ju vidí v Dokumentoch.
 */
export default function OverdueBanner({ isAdmin }: { isAdmin: boolean }) {
  const { t } = useTranslation()
  const { data } = useQuery({
    queryKey: ['billing-status'],
    queryFn: billing.status,
    staleTime: 30 * 60 * 1000,
  })
  const invoice = data?.overdue[0]
  if (!invoice) return null

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 bg-red-600 px-4 py-2 text-sm text-white">
      <AlertTriangle size={16} className="shrink-0" />
      <span className="flex-1">
        {t('billing.overdue', {
          number: invoice.number,
          total: formatMoney(Number(invoice.total)),
          payBy: formatDate(invoice.pay_by),
          suspendOn: formatDate(invoice.suspend_on),
        })}
      </span>
      {isAdmin ? (
        <Link to="/settings/documents" className="font-semibold underline underline-offset-2">
          {t('billing.showInvoice')}
        </Link>
      ) : null}
    </div>
  )
}
